/**
 * Supabase client (browser).
 *
 * SECURITY
 * - Uses REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_PUBLISHABLE_KEY.
 * - The publishable ("anon") key is safe for the browser as long as RLS is on.
 * - Never place the service_role / secret key here.
 *
 * SESSION
 * - persistSession + autoRefreshToken enabled so Supabase manages login state
 *   automatically. We do NOT store a custom JWT in localStorage anywhere else.
 */
import { createClient } from "@supabase/supabase-js";

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;

export const isSupabaseConfigured = Boolean(url && publishableKey);

export const supabase = isSupabaseConfigured
  ? createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "pkce",
        storageKey: "agenaix.auth",
      },
    })
  : null;

export default supabase;
